import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import axios from "axios";
import { CustomCheckBox } from "hesus-ui-kit";
import { useGetGeneralParameters } from "@hooks/useGeneralParams";
import { CheckboxGridRow, DepartmentCountText } from "./Department.styled";
import {
  ErrorLabel,
  ComponentContainer,
  ComponentContainerEmpty,
} from "../../AddEditCenterProductPrice.styled";

const Department = (props) => {
  const {
    t,
    selectedDepartment,
    setDepartmentCatchmentValueChange,
    error,
    countryId,
  } = props;

  const generalParams = useGetGeneralParameters();
  const [departmentList, setDepartmentList] = useState(
    generalParams?.departmentList ?? []
  );

  useEffect(() => {
    if (!countryId) return;
    axios
      .get(`/general/countryDepartments?countryId=${countryId}`)
      .then((response) => {
        setDepartmentList(response?.data?.department ?? []);
      })
      .catch(() => {});
  }, [countryId]);

  const onDepartmentClick = (e, id) => {
    if (selectedDepartment.indexOf(id) === -1 && e.currentTarget.checked)
      selectedDepartment.push(id);
    else {
      const index = selectedDepartment.indexOf(id.toString());
      if (index >= 0) {
        selectedDepartment.splice(index, 1);
      }
    }
    setDepartmentCatchmentValueChange(
      selectedDepartment.length > 0 ? selectedDepartment.join() : ""
    );
  };

  const selectAllDepartment = (e) => {
    if (e.currentTarget.checked)
      setDepartmentCatchmentValueChange(
        departmentList.map((obj) => obj.id).join()
      );
    else setDepartmentCatchmentValueChange("");
  };
  return (
    <>
      {departmentList?.length > 0 && (
        <CustomCheckBox
          id="select-all"
          key="select-all"
          labelText={t("SELECT_ALL")}
          dataId="selectAll"
          onChange={(e) => {
            selectAllDepartment(e);
          }}
          checked={selectedDepartment.length === departmentList.length}
        />
      )}

      {departmentList?.length > 0 && (
        <ComponentContainer error={error !== ""}>
          <CheckboxGridRow column="1fr 1fr 1fr">
            {departmentList.map((department) => (
              <div
                style={{ margin: "5px 0 5px 0" }}
                key={`${department.code}${"-"}${department.name}`}
              >
                <CustomCheckBox
                  id={department.id}
                  key={department.id}
                  labelText={`${department.code}${"-"}${department.name}`}
                  dataId={department.id}
                  onChange={(e) => {
                    onDepartmentClick(e, department.id);
                  }}
                  checked={
                    selectedDepartment.indexOf(department.id.toString()) !== -1
                  }
                />
              </div>
            ))}
          </CheckboxGridRow>
        </ComponentContainer>
      )}
      {departmentList?.length === 0 && (
        <ComponentContainerEmpty error={error !== ""}>
          {t("NO_DEPARTMENTS")}
        </ComponentContainerEmpty>
      )}

      {error !== "" && <ErrorLabel>{t("ERROR_MISSING_DEPARTMENT")}</ErrorLabel>}
      <DepartmentCountText>
        {selectedDepartment.length} {t("SELECTED_DEPARTMENTS_COUNTER")}
      </DepartmentCountText>
    </>
  );
};

Department.propTypes = {
  t: PropTypes.func.isRequired,
  countryId: PropTypes.number,
};

Department.defaultProps = {
  countryId: null,
};
export default withTranslation()(Department);
